export * from './lib/blocks.module';
